import { render, staticRenderFns } from "./FooterDropdown.vue?vue&type=template&id=3d12321c&scoped=true&"
import script from "./FooterDropdown.vue?vue&type=script&lang=js&"
export * from "./FooterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FooterDropdown.vue?vue&type=style&index=0&id=3d12321c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d12321c",
  null
  
)

export default component.exports